import { DailyLessonDay } from './daily_lesson_day';
import { DailyLesson } from './daily_lesson';
export class DailyLessonVolume {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volumeNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCurrentVolume", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finishedDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "days", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.volumeNumber = data.volumeNumber;
        this.isCompleted = data.isCompleted;
        this.isCurrentVolume = data.isCurrentVolume;
        this.totalLessons = data.totalLessons;
        this.finishedDays = data.finishedDays;
        this.dailyLesson = data.dailyLesson ? new DailyLesson(data.dailyLesson, config) : null;
        this.days = data.days ? data.days.map((o) => new DailyLessonDay(o, config)) : [];
    }
    nextVolumeNumber() {
        return this.volumeNumber + 1;
    }
}
